import { Grid, Link, Typography } from "@mui/material";
import BodyContainer from "../components/BodyContainer";
import AppHeader from "../components/AppHeader";
import FooterButtons from "../components/FooterButtons";
import { appRoutes } from "../AppRoutes";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearAll } from "../store/submission.slice";
import { PDFReviewDownloadButton } from "../components/PDFReview";

const SubmitSuccess = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const closeApp = () => {
		clearForms();
		window.close();
		navigate(appRoutes.Home);
	}

	const clearForms = () => {
		dispatch(clearAll());
	}

	return (
		<>
			<AppHeader />
			<BodyContainer hasFooter={false} hasHeader={true}>
				<Grid item xs="auto" mb={4} mt={2} sx={{ width: '100% !important' }}>
					<>
						<Typography variant="title" component="h1">Submitted Successfully</Typography>
						<Typography variant="subtitle2" component="h2">
							Congratulations. Your burn has been submitted.  You can download a PDF copy of your submission for your records using the link below.  Please note that the record must be downloaded prior to closing this application.
						</Typography>
						<Typography variant="subtitle2" component="h2">
							You may also Contact ADA dispatch center (<Link color="inherit" href="tel:1-800-830-8015">1-800-830-8015</Link>) if you have questions. Note that some data will be purged and no longer available after two days for a row crop burn submission and after two weeks for a Forest Industry & Landowner submission. 
						</Typography>
					</>
				</Grid>
				<Grid item xs={8} mt={2} sx={{ width: '100% !important' }}>
					<Typography mb={2} mt={2} variant="subtitle2" component="h2" align="center">
						<PDFReviewDownloadButton onClick={() => {}} />
					</Typography>
				</Grid>
				<Grid item xs={8} mt={2} sx={{ width: '100% !important' }}>
					<Typography variant="subtitle2" component="h2">
						 If you need updated fire weather information, visit <Link color="inherit" href="https://www.weather.gov/lzk/forest2.htm">https://www.weather.gov/lzk/forest2.htm </Link> and search by zip code on the upper left of the webpage.
					</Typography>
				</Grid>
				<Grid item xs="auto" mt={4} sx={{width: '100% !important', minWidth: '182px !important'}}>
					<FooterButtons hideBack={true} onNext={closeApp} nextLabel="Close" />
				</Grid>
			</BodyContainer>
		</>
	)
}

export default SubmitSuccess;